import type { Attachment, ComposerRuntime } from '@assistant-ui/react';

// Re-adding just the missing item appends it after retained attachments. Replay
// the ordered snapshot through the public adapter API instead. Pending files
// remain files (including image preprocessing); complete attachments retain
// their original content, names and IDs. The composer is disabled during replay.
export async function restoreAttachmentOrder(
  composer: Pick<ComposerRuntime, 'clearAttachments' | 'addAttachment'>,
  attachments: readonly Attachment[],
) {
  await composer.clearAttachments();
  for (const attachment of attachments) {
    if (attachment.file) await composer.addAttachment(attachment.file);
    else if (attachment.status.type === 'complete')
      await composer.addAttachment({
        id: attachment.id,
        type: attachment.type,
        name: attachment.name,
        contentType: attachment.contentType,
        content: attachment.content!,
      });
  }
}
